<template>
  <div class="salesMansTabs">
    <div class="common-box-body" style="padding-top:15px;padding-bottom:0">
      <div class="label-wrap clearfix">
        <div class="floatl label-name">
          您已选择
        </div>
        <div class="label-list" style="height: auto;">
          <div v-if="checkboxGroup.length>0" class="industryCategory">
            行业品类:
            <span>{{checkboxGroup.join("、")}}</span>
            <span class="remove-btn" @click="deleteSelfLabel(1)"></span>
          </div>
          <div v-if="checkboxGroup1.length>0 " class="industryCategory">
            岗位类型:
            <span>{{checkboxGroup1.join("、")}}</span>
            <span class="remove-btn" @click="deleteSelfLabel(2)"></span>
          </div>
          <div v-if="checkboxGroup2.length>0" class="industryCategory">
            自我标签：
            <span>{{checkboxGroup2.join("、")}}</span>
            <span class="remove-btn" @click="deleteSelfLabel(3)"></span>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top:15px;">
      <div class="label-wrap clearfix">
        <div class="floatl label-name" style="margin-right:-10px">
          行业品类
        </div>
        <div class="label-list" ref="slideWrap">
          <div class="toggle-btn" @click="toggleSlide"></div>
          <div class="label-tabs">
            <el-checkbox-group v-model="checkboxGroup" size="small" @change="integrationIds">
              <el-checkbox @change="showTabs(item,$event)" style="margin-left:10px;" :label="item.signName"
                           v-for="item in tabsData" :key="item.id" border></el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
    </div>
    <div style="padding:0;" v-if="postId == 0">
      <div class="label-wrap clearfix">
        <div class="floatl label-name" style="margin-right:-10px">
          岗位类型
        </div>
        <div class="label-list clearfix" ref="slideWrap">
          <div class="toggle-btn" @click="toggleSlide"></div>
          <div class="label-tabs">
            <el-checkbox-group v-model="checkboxGroup1" size="small" @change="integrationIds">
              <el-checkbox @change="showTabs(item,$event)" style="margin-left:10px;" :label="item.signName"
                           v-for="item in tabsData2" :key="item.id" border></el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
    </div>
    <div style="padding:0;">
      <div class="label-wrap clearfix">
        <div class="floatl label-name" style="margin-right:-10px">
          自我标签
        </div>
        <div class="label-list clearfix" ref="slideWrap">
          <div class="toggle-btn" @click="toggleSlide"></div>
          <div class="label-tabs">
            <el-checkbox-group v-model="checkboxGroup2" size="small" @change="integrationIds">
              <el-checkbox @change="showTabs(item,$event)" style="margin-left:10px;" :label="item.signName"
                           v-for="item in tabsData3" :key="item.id" border></el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['postId'],
    data() {
      return {
        checkboxGroup: [],
        checkboxGroup1: [],
        checkboxGroup2: [],
        checkboxIds: [],
        tabsData: [],
        tabsData2: [],
        tabsData3: [],
      }
    },

    mounted() {
      // console.log('this.postId', this.postId)
      this.getIndustryLabel()
      this.getJobLabel()
      this.getSelfLabel()
      
      window.onresize = () => {
        return this.autoResize()
      }

    },
    methods: {
      //自动根据标签div的高度，添加或移除下拉小按钮。除此之外，在获取三类标签后，且渲染后，各执行一次。
      autoResize(){
        var arr = document.getElementsByClassName('label-tabs')
        if(arr.length != 0){
          for (let i = 0; i < arr.length; i++) {//注意如果在引用了此组件 的页面里加了label-tabs类，一定要小心，记得关注这里
            // console.log(i,arr[i])
            // console.log(i,arr[i].offsetHeight)
            if (arr[i].offsetHeight < 51) {
              arr[i].previousElementSibling.setAttribute("style", "display:none;")
            } else {
              arr[i].previousElementSibling.setAttribute("style", "display:block;")
            }
            if(i==2){//因为有的时候arr不足3个，i上限是length，有时候大于3个，所以到3就停止
              break;
            }
          }
        }
      },
      toggleSlide(event) {
        let target = event.target
        let parentNode = target.parentNode
        if (parentNode.offsetHeight > 40) {
          target.className = 'toggle-btn'
          parentNode.style.height = 40 + 'px'
        } else {
          target.className = 'toggle-btn up'
          parentNode.style.height = 'auto'
        }
      },
      // 获取行业类型二级标签
      getIndustryLabel() {
        // this.$http({
        //   method:"GET",
        //   url:'/rest/PublishedWork/searchSignName',
        //   params: {
        //     signType: 1,
        //     signLevel:2
        //   }
        // }).then(res => {
        //   let data = res.data
        //   this.tabsData = data
        // }).catch(err => {
        //  	let errMsg;
        //     if(err.response.message){
        //      	errMsg = err.response.message
        //     }else{
        //      	errMsg = '查询失败，请稍后重试'
        //     }
        // 	  this.$notify({
        // 	    title: '失败',
        // 	    message: errMsg,
        // 	    type: 'error'
        // 	  })
        // })


        this.$http({
          method: "GET",
          url: '/rest/PublishedWork/searchIndustrySignName',
          params: {
            signType: 1,
            signLevel: 2
          }
        }).then(res => {
          let data = res.data
          this.tabsData = data

          setTimeout( () => {
            this.autoResize()//校验一下高度，添加下拉小按钮
          },100)
        }).catch(err => {
          let errMsg;
          if (err.response.message) {
            errMsg = err.response.message
          } else {
            errMsg = '查询失败，请稍后重试'
          }
          this.$notify({
            title: '失败',
            message: errMsg,
            type: 'error'
          })
        })
      },
      // 获取岗位标签
      getJobLabel() {
        this.$http({
          method: "GET",
          url: '/rest/PublishedWork/searchSignName',
          params: {
            signType: 2,
          }
        }).then(res => {
          let data = res.data
          this.tabsData2 = data

          setTimeout( () => {
            this.autoResize()//校验一下高度，添加下拉小按钮
          },100)
        }).catch(err => {
          let errMsg;
          if (err.response.message) {
            errMsg = err.response.message
          } else {
            errMsg = '查询失败，请稍后重试'
          }
          this.$notify({
            title: '失败',
            message: errMsg,
            type: 'error'
          })
        })
      },
      // 获取自我标签
      getSelfLabel() {
        this.$http({
          method: "GET",
          url: '/rest/PublishedWork/searchSignName',
          params: {
            signType: 3,
          }
        }).then(res => {
          let data = res.data
          this.tabsData3 = data

          setTimeout( () => {
            this.autoResize()//校验一下高度，添加下拉小按钮
          },100)
        }).catch(err => {
          let errMsg;
          if (err.response.message) {
            errMsg = err.response.message
          } else {
            errMsg = '查询失败，请稍后重试'
          }
          this.$notify({
            title: '失败',
            message: errMsg,
            type: 'error'
          })
        })
      },
      showTabs(tab, e) {
        let _this = this
        if (this.checkboxIds.indexOf(tab.id) < 0 && e) {
          this.checkboxIds.push(tab.id)
        }
        if (!e) {
          this.checkboxIds.forEach((item, index, arr) => {
            if (item == tab.id) {
              delete _this.checkboxIds[index]
            }
          })
        }
      },
      integrationIds() {
        let signIdLst = []
        this.checkboxIds.forEach((item, index, arr) => {
          signIdLst.push(item)
        })
        this.$emit('signId-Lst', signIdLst);
      },
      // 清空行业品类所选
      deleteSelfLabel(val) {
        if (val == 1) {
          let rows = []
          this.checkboxGroup.forEach(item => {
            this.tabsData.forEach((item2, index2, arr2) => {
              if (item == item2.signName) {
                rows.push(item2)
              }
            })
          })
          rows.forEach(item => {
            this.checkboxIds.forEach((item2, index, arr) => {
              if (item.id == item2) {
                this.checkboxIds.splice(index, 1)
              }
            })
          })
          this.checkboxGroup = []
        } else if (val == 2) {

          let rows = []
          this.checkboxGroup1.forEach(item => {
            this.tabsData2.forEach((item2, index2, arr2) => {
              if (item == item2.signName) {
                rows.push(item2)
              }
            })
          })
          rows.forEach(item => {
            this.checkboxIds.forEach((item2, index, arr) => {
              if (item.id == item2) {
                this.checkboxIds.splice(index, 1)
              }
            })
          })
          this.checkboxGroup1 = []
        } else {

          let rows = []
          this.checkboxGroup2.forEach(item => {
            this.tabsData3.forEach((item2, index2, arr2) => {
              if (item == item2.signName) {
                rows.push(item2)
              }
            })
          })
          rows.forEach(item => {
            this.checkboxIds.forEach((item2, index, arr) => {
              if (item.id == item2) {
                this.checkboxIds.splice(index, 1)
              }
            })
          })
          this.checkboxGroup2 = []
        }
        this.integrationIds()
      },
      //清空全部所选
      reset(){
        this.deleteSelfLabel(1)
        this.deleteSelfLabel(2)
        this.deleteSelfLabel(3)
      },
    }
  }
</script>

<style lang="scss">
  @import "../common/styles/variable.scss";
  
  .label-wrap {
    width: 100%;
    //background-color: #f8f8f8;
    border-radius: 5px;
    padding: 0px 10px 0;
    box-sizing: border-box;
    margin-bottom: 10px;
    .label-tabs {
      width: 97%;
      .checkbox-group {
        width: 100%;
      }
    }
    .label-name {
      width: 80px;
      font-size: 14px;
      color: #333;
      line-height: 30px;
      padding-left: 10px;
      box-sizing: border-box;
      
    }
    .label-list {
      position: relative;
      height: 40px;
      line-height: 40px;
      overflow: hidden;
      .toggle-btn {
        position: absolute;
        width: 16px;
        height: 16px;
        top: 6px;
        right: 0;
        background-image: url(../common/images/11zhankai.png);
        background-repeat: no-repeat;
        background-position: top left;
        z-index: 99;
        &.up {
          background-image: url(../common/images/12shouqi.png);
        }
      }
      // .label-tabs{
      //  height:40px;
      //  // margin-top:-5px;
      // }
    }
    .industryCategory {
      height: auto;
      line-height: 30px;
      padding: 0 10px 0 20px;
      float: left;
      color: #fff;
      background: #8299dc;
      border-radius: 15px;
      margin-right: 10px;
      margin-bottom: 10px;
      .remove-btn {
        display: inline-block;
        width: 20px;
        height: 20px;
        vertical-align: middle;
        margin-left: 20px;
        margin-top: -2px;
        background: url(../common/images/shan2.png) no-repeat center;
      }
    }
  }
  
  .label-tabs .el-checkbox {
    background: #f8f8f8;
    border-color: #eaeaea;
    
  }
  
  .label-tabs .el-checkbox.is-bordered.is-checked {
    background: #8299dc;
    
  }
  
  .label-tabs .el-checkbox.is-bordered.is-checked .el-checkbox__label {
    color: #fff
  }
  
  .label-tabs .el-checkbox .el-checkbox__input {
    display: none;
  }
  
  // .tag-container{
  //   .label{
  //     width: 90px;
  //     height: 28px;
  //     box-sizing: border-box;
  //     color: #5a5e66;
  //     cursor: default;
  //     font-family: Arial, "Microsoft YaHei", sans-serif;
  //     font-size: 14px;
  //     line-height: 28px;
  //     padding: 0 12px 0 0;
  //     text-align: right;
  //     vertical-align: middle;
  //   }
  //   .content{
  //     margin-left: 90px;
  //     padding-right: 80px;
  //   }
  //   .selected-tag{
  //     width: 100%;
  //     margin: 10px 0 20px;
  //     .label{
  //       height: 30px;
  //       line-height: 30px;
  //     }
  //     .selected-tag-item{
  //       display: inline-block;
  //       margin-right: 10px;
  //       height: 30px;
  //       line-height: 30px;
  //       padding: 0 10px;
  //       border-radius: 15px;
  //       background-color: $theme-color;
  //       color: #fff;
  //       i{
  //         font-size: 16px;
  //         margin-left: 20px;
  //         line-height: 30px;
  //       }
  //     }
  //   }
  //   .tags{
  //     width: 100%;
  //     height: 42px;
  //     overflow: hidden;
  //     position: relative;
  //     .tag-item{
  //       margin-right: 10px;
  //       margin-bottom: 10px;
  //     }
  //     .toggle-btn{
  //       position: absolute;
  //       top: 5px;
  //       right: 0;
  //       width: 16px;
  //       height: 16px;
  //       background-image: url(../common/images/11zhankai.png)
  //     }
  //     .toggle-btn.up{
  //       background-image: url(../common/images/12shouqi.png)
  //     }
  //   }
  // }
</style>




// WEBPACK FOOTER //
// src/components/filterTag.vue